export default [
  'addresstype',
  'alertanalyzersettings',
  'characteristic',
  'city',
  'communicationtype',
  'contact',
  'contactstatus',
  'contactcommunication',
  // 'density',
  // 'document',
  'documenttype',
  'documentstatus',
  // 'event',
  'goods',
  'goodscharacteristic',
  'goodsgroup',
  'devices',
  'devicestatuses',
  'goodsstatus',
  'operationtype',
  'organization',
  'organizationaddress',
  'orgcommunication',
  'organizationstatus',
  'organizationtype',
  'deliverytype',
  'plugcomstatus',
  'userstatus',
  'region',
  // 'remain',
  'role',
  'unit',
  'user',
  'constants',
]
